module.exports = __webpack_public_path__ + "img/4.ecadb9b6.png";